import { GripVertical, X, Lock } from 'lucide-react';
import { cn } from '../../lib/utils';
import { Button } from '../ui/button';

const WidgetContainer = ({ children, widgetKey, isEditMode, isLocked, onRemove }) => {
  return (
    <div
      className={cn(
        'citius-widget-capture-shell relative h-full overflow-hidden rounded-xl border border-border/45 bg-card/80 shadow-sm backdrop-blur-md transition-all ring-1 ring-inset ring-primary/5',
        isEditMode && 'ring-2 ring-primary/25'
      )}
    >
      {isEditMode && (
        <div className='absolute top-2 right-2 z-10 flex items-center gap-1'>
          <div
            className='widget-drag-handle cursor-move p-1 bg-background/80 backdrop-blur-sm rounded hover:bg-accent'
            title='Drag to move'
          >
            <GripVertical className='h-4 w-4 text-muted-foreground' />
          </div>

          {!isLocked ? (
            <Button
              variant='ghost'
              size='icon'
              className='h-7 w-7 bg-background/80 backdrop-blur-sm hover:bg-destructive hover:text-destructive-foreground'
              onClick={onRemove}
              title='Remove widget'
            >
              <X className='h-4 w-4' />
            </Button>
          ) : (
            <div
              className='p-1 bg-background/80 backdrop-blur-sm rounded'
              title='This widget is required'
            >
              <Lock className='h-4 w-4 text-muted-foreground' />
            </div>
          )}
        </div>
      )}

      <div className='h-full overflow-hidden'>
        {children}
      </div>
    </div>
  );
};

export default WidgetContainer;
